import { useQuery } from '@apollo/client';
import {
    GET_WATER_USE_WATER_SYSTEM,
    GET_WATER_USE_SYSTEM_USAGE_YEARS_SOURCES,
    GET_WATER_USE_WATER_SYSTEM_ANNUAL_USE,
    GET_WATER_USE_WATER_SYSTEM_PEAK_DATA,
    GET_WATER_USE_ENGINEERS,
} from '../../../queries/engineeringQrys';

/**
 * @param {string} pwsId - The full PWS ID (e.g., "UTAH12345")
 * @param {number[]} years - Array of years to fetch data for
 * @param {string[]} selectedSources - Optional array of selected source IDs
 */
const useDwriData = ({ pwsId, years, selectedSources = [] }) => {
    const skipInfo = !pwsId;
    const skipYearBased = !pwsId || years.length === 0;
    const sourceFilter = selectedSources.length > 0 ? selectedSources : undefined;

    const {
        data: infoData,
        loading: infoLoading,
        error: infoError,
    } = useQuery(GET_WATER_USE_WATER_SYSTEM, {
        variables: { pwsId },
        skip: skipInfo,
        fetchPolicy: 'cache-and-network',
    });

    const {
        data: yearsSourcesData,
        loading: yearsSourcesLoading,
        error: yearsSourcesError,
    } = useQuery(GET_WATER_USE_SYSTEM_USAGE_YEARS_SOURCES, {
        variables: { pwsId },
        skip: skipInfo,
        fetchPolicy: 'cache-and-network',
    });

    const {
        data: annualUseData,
        loading: annualUseLoading,
        error: annualUseError,
    } = useQuery(GET_WATER_USE_WATER_SYSTEM_ANNUAL_USE, {
        variables: { pwsId, years, sources: sourceFilter },
        skip: skipYearBased,
        fetchPolicy: 'cache-and-network',
    });

    const {
        data: peakData,
        loading: peakLoading,
        error: peakError,
    } = useQuery(GET_WATER_USE_WATER_SYSTEM_PEAK_DATA, {
        variables: { pwsId, years, sources: sourceFilter },
        skip: skipYearBased,
        fetchPolicy: 'cache-and-network',
    });

    const {
        data: engineersData,
        loading: engineersLoading,
        error: engineersError,
    } = useQuery(GET_WATER_USE_ENGINEERS, {
        fetchPolicy: 'cache-and-network',
    });

    return {
        systemInfo: infoData?.getWaterUseSystem || null,
        systemName: infoData?.getWaterUseSystem?.systemName,
        years: yearsSourcesData?.getWaterUseSystemUsageYearsSources?.years || [],
        sources: yearsSourcesData?.getWaterUseSystemUsageYearsSources?.sources || [],
        assignableEngineers: engineersData?.getWaterUseEngineers || [],
        systemAnnualUse: annualUseData?.getWaterUseSystemAnnualUse?.SystemAnnualUse || [],
        waterUseSources: annualUseData?.getWaterUseSystemAnnualUse?.WaterUseSources || [],
        peakDayData: peakData?.getWaterUseSystemPeakData?.peakDemand || [],
        peakMonthData: peakData?.getWaterUseSystemPeakData?.peakMonthDemand || [],
        loading: {
            info: infoLoading,
            yearsSources: yearsSourcesLoading,
            annualUse: annualUseLoading,
            peak: peakLoading,
            engineers: engineersLoading,
        },
        errors: {
            info: infoError,
            yearsSources: yearsSourcesError,
            annualUse: annualUseError,
            peak: peakError,
            engineers: engineersError,
        },
    };
};

export default useDwriData;
